// ═══════════════════════════════════════════════════════════════════════════════
// NAVBAR FIXE EN BAS - COCKPIT PARTICULIER MOBILE
// Espace | Marketplace | Réseau | Service | Emploi
// Navigation DIRECTE vers les vraies pages via React Router
// Réutilisable dans toutes les pages du Cockpit Particulier
// ═══════════════════════════════════════════════════════════════════════════════

import { useNavigate, useLocation } from 'react-router-dom';

export default function CockpitParticulierBottomNav({ forceReload = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Handler de navigation - Force reload si demandé (pour contourner le piège de state de CockpitAssistantUnified)
  const handleNav = (path) => {
    if (forceReload) {
      window.location.href = path;
    } else {
      navigate(path);
    }
  };
  
  // Fonction pour déterminer si un onglet est actif
  const isEspaceActive = location.pathname === '/cockpit-particulier' || 
    location.pathname.includes('/cockpit-particulier/annonces') || 
    location.pathname.includes('/cockpit-particulier/favoris') || 
    location.pathname.includes('/cockpit-particulier/taches') || 
    location.pathname.includes('/cockpit-particulier/groupes') ||
    location.pathname.includes('/cockpit-particulier/cercles') ||
    location.pathname.includes('/cockpit-particulier/messagerie') ||
    location.pathname.includes('/cockpit-particulier/profil') ||
    location.pathname.includes('/cockpit-particulier/parametres') ||
    location.pathname.includes('/cockpit-particulier/notes') ||
    location.pathname.includes('/cockpit-particulier/agenda') ||
    location.pathname.includes('/cockpit-particulier/documents') ||
    location.pathname.includes('/cockpit-particulier/mails') ||
    location.pathname.includes('/cockpit-particulier/visio');
    
  const isMarketplaceActive = location.pathname.includes('/cockpit-particulier/marketplace');
  const isReseauActive = location.pathname.includes('/cockpit-particulier/reseau');
  const isServiceActive = location.pathname.includes('/cockpit-particulier/artisans');
  const isEmploiActive = location.pathname.includes('/cockpit-particulier/emploi');
  
  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-[9999] border-t border-[#2A4A6F] md:hidden" 
      style={{ background: '#1E3A5F' }}
    >
      <div className="grid grid-cols-5 items-center justify-items-center" style={{ height: '60px' }}>
        {/* Espace - Dashboard principal */}
        <button 
          onClick={() => handleNav('/cockpit-particulier')}
          className="flex flex-col items-center justify-center gap-[2px] w-full h-full" 
          data-testid="fixed-nav-espace"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={isEspaceActive ? '#F97316' : 'rgba(255,255,255,0.75)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          <span style={{ color: isEspaceActive ? '#F97316' : 'rgba(255,255,255,0.75)', fontSize: '9px', fontWeight: isEspaceActive ? 600 : 500 }}>Espace</span>
        </button>
        
        {/* Marketplace - Achats Pros */}
        <button 
          onClick={() => handleNav('/cockpit-particulier/marketplace')}
          className="flex flex-col items-center justify-center gap-[2px] w-full h-full" 
          data-testid="fixed-nav-marketplace"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={isMarketplaceActive ? '#F97316' : 'rgba(255,255,255,0.75)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 0 1-8 0"/>
          </svg>
          <span style={{ color: isMarketplaceActive ? '#F97316' : 'rgba(255,255,255,0.75)', fontSize: '9px', fontWeight: isMarketplaceActive ? 600 : 500 }}>Marketplace</span>
        </button>
        
        {/* Réseau - Réseau Social */}
        <button 
          onClick={() => handleNav('/cockpit-particulier/reseau')}
          className="flex flex-col items-center justify-center gap-[2px] w-full h-full" 
          data-testid="fixed-nav-reseau"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={isReseauActive ? '#F97316' : 'rgba(255,255,255,0.75)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          <span style={{ color: isReseauActive ? '#F97316' : 'rgba(255,255,255,0.75)', fontSize: '9px', fontWeight: isReseauActive ? 600 : 500 }}>Réseau</span>
        </button>
        
        {/* Service - Artisans/Prestataires */}
        <button 
          onClick={() => handleNav('/cockpit-particulier/artisans')}
          className="flex flex-col items-center justify-center gap-[2px] w-full h-full" 
          data-testid="fixed-nav-service"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={isServiceActive ? '#F97316' : 'rgba(255,255,255,0.75)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
          </svg>
          <span style={{ color: isServiceActive ? '#F97316' : 'rgba(255,255,255,0.75)', fontSize: '9px', fontWeight: isServiceActive ? 600 : 500 }}>Service</span>
        </button>
        
        {/* Emploi */}
        <button 
          onClick={() => handleNav('/cockpit-particulier/emploi')}
          className="flex flex-col items-center justify-center gap-[2px] w-full h-full" 
          data-testid="fixed-nav-emploi"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={isEmploiActive ? '#F97316' : 'rgba(255,255,255,0.75)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
          </svg>
          <span style={{ color: isEmploiActive ? '#F97316' : 'rgba(255,255,255,0.75)', fontSize: '9px', fontWeight: isEmploiActive ? 600 : 500 }}>Emploi</span>
        </button>
      </div>
      {/* Safe area padding pour iPhone */}
      <div style={{ height: 'env(safe-area-inset-bottom, 0px)', background: '#1E3A5F' }} />
    </div>
  );
}
